import { CashdroAlert, CashdroLevels } from './../interfaces/cashdro-specific-responses-interface';
import {
  BCCashdropResponseInterface,
  CashdroResponse,
} from './../interfaces/cashdro-api-response-interface';
import { CashdroProxyServiceInterface } from './../interfaces/cashdro-proxy-service-interface';
import BPCApiRouteHelper from '@core/helpers/bpc-api-route.helper';
import { Terminal } from '@payment-terminals/interfaces/terminal';
import { BCCashdroResponse } from '@pos/interfaces/cashdro-api-response-interface';
import { CashdroStartOperationResponse } from '@pos/interfaces/cashdro-specific-responses-interface';
import CashdroErrorHelper from '@pos/helpers/cashdro-error-helper';
import {
  BCCashdroExecutingOperationsResponse,
  BCCashdroOperationsStatusResponse,
} from '@pos/interfaces/bc-cashdro-specific-response-interface';

export default class CashdroFakeProxyService implements CashdroProxyServiceInterface {
  API_ENDPOINT = 'Cashdro3WS';
  WEB_ENDPOINT: 'Cashdro3Web';

  protected $bpcApiRouteHelper: BPCApiRouteHelper;
  protected $errorHelper: CashdroErrorHelper;

  constructor() {
    this.$bpcApiRouteHelper = new BPCApiRouteHelper();
    this.$errorHelper = new CashdroErrorHelper();
  }

  FAKE_UNITS_ALERTS_STATUS = 'ok'; // change to ko to test FAKE WRONG STATUS terminal errors
  FAKE_UNITS_ALERTS_WRONG_STATUS = 'authentication_error'; // Global errors: '404' | 'authentication_error'
  FAKE_SHOW_UNITS_ALERTS = true; // true false

  async getTerminalUnitsAlerts(terminal: Terminal): Promise<BCCashdropResponseInterface<unknown>> {
    await this.sleep(1000);
    if (this.FAKE_UNITS_ALERTS_STATUS === 'ok') {
      if (this.FAKE_SHOW_UNITS_ALERTS) {
        const alerts: CashdroAlert[] = [
          {
            AlertId: '4',
            Source: '1',
            Value: '200',
            Type: '0',
            CurrencyId: 'EUR',
          },
          {
            AlertId: '1',
            Source: '2',
            Value: '500',
            Type: '5',
            CurrencyId: 'EUR',
          },
        ];
        const responseData = {
          code: 1,
          response: {
            errorMessage: 'none',
            operation: {
              Alerts: alerts,
            },
          },
        };

        return new BCCashdroResponse(
          false,
          responseData,
          this.$errorHelper.cashdroUnitTermilansWithAlersError(),
        );
      } else {
        return new BCCashdroResponse(true, { code: 1, response: '' }, null);
      }
    } else {
      switch (this.FAKE_UNITS_ALERTS_WRONG_STATUS) {
        // Incorrect user and/or password
        case 'authentication_error':
          return this.getCashdroAuthenticationExceptionResponse();
          break;
        // Impossible to connect with the terminal
        case '404':
          return this.getCashdroConnectionExceptionResponse();
          break;
        default:
          return this.getCashdroGenericExceptionResponse();
          break;
      }
    }
  }

  FAKE_LEVELS_STATUS = 'ok'; // change to ko to test FAKE WRONG STATUS terminal errors
  FAKE_LEVELS_WRONG_STATUS = 'authentication_error'; // Global errors: '404' | 'authentication_error'
  FAKE_CORRECT_LEVELS = true; // true | false

  async getTerminalLevels(terminal: Terminal): Promise<BCCashdropResponseInterface<unknown>> {
    await this.sleep(500);
    if (this.FAKE_LEVELS_STATUS === 'ok') {
      const levels: CashdroLevels[] = [
        {
          CurrencyId: 'EUR',
          Value: '1',
          Type: '1',
          MinLevel: '1000',
          MaxLevel: '5000',
          DepositLevel: '3000',
          MaxPiecesExchange: '1000',
          State: '-1', // There is no alert
          Destination: '1',
          Image: '',
          LevelCassete: '3000',
          LevelRecycler: '0',
        },
        {
          CurrencyId: 'EUR',
          Value: '10',
          Type: '1',
          MinLevel: '10000',
          MaxLevel: '50000',
          DepositLevel: '12000',
          MaxPiecesExchange: '10000',
          State: '0', // Critical Level
          Destination: '1',
          Image: '',
          LevelCassete: '12000',
          LevelRecycler: '0',
        },
        {
          CurrencyId: 'EUR',
          Value: '20',
          Type: '1',
          MinLevel: '10000',
          MaxLevel: '50000',
          DepositLevel: '12000',
          MaxPiecesExchange: '10000',
          State: '1', // Inhibition Level
          Destination: '1',
          Image: '',
          LevelCassete: '12000',
          LevelRecycler: '0',
        },
        {
          CurrencyId: 'EUR',
          Value: '100',
          Type: '2',
          MinLevel: '50000',
          MaxLevel: '100000',
          DepositLevel: '48000',
          MaxPiecesExchange: '50000',
          State: '2', //Level Below Minimun
          Destination: '1',
          Image: '',
          LevelCassete: '48000',
          LevelRecycler: '0',
        },
        {
          CurrencyId: 'EUR',
          Value: '500',
          Type: '2',
          MinLevel: '10000',
          MaxLevel: '60000',
          DepositLevel: '65000',
          MaxPiecesExchange: '10000',
          State: '3', //Level Above Maximun
          Destination: '1',
          Image: '',
          LevelCassete: '65000',
          LevelRecycler: '0',
        },
        {
          CurrencyId: 'EUR',
          Value: '10000',
          Type: '2',
          MinLevel: '20000',
          MaxLevel: '60000',
          DepositLevel: '0',
          MaxPiecesExchange: '20000',
          State: '5', //Level is zero
          Destination: '1',
          Image: '',
          LevelCassete: '0',
          LevelRecycler: '0',
        },
      ];
      const responseData = {
        code: 1,
        response: {
          errorMessage: 'none',
          operation: {
            pieces: levels,
          },
        },
      };

      return new BCCashdroResponse(
        this.FAKE_CORRECT_LEVELS,
        responseData.response,
        this.FAKE_CORRECT_LEVELS ? null : this.$errorHelper.cashdroUnitTermilansWithAlersError(),
      );
    } else {
      switch (this.FAKE_LEVELS_WRONG_STATUS) {
        // Incorrect user and/or password
        case 'authentication_error':
          return this.getCashdroAuthenticationExceptionResponse();
          break;
        // Impossible to connect with the terminal
        case '404':
          return this.getCashdroConnectionExceptionResponse();
          break;
        default:
          return this.getCashdroGenericExceptionResponse();
          break;
      }
    }
  }

  FAKE_IMPORT_OPERATION_STATUS = 'ok';
  // Global errors: '404' | 'authentication_error'
  // Specific erors for getOperationStatus : 'operation_not_found' | 'invalid_parameters'
  FAKE_IMPORT_OPERATION_WRONG_STATUS = '';
  async importOperation(
    terminal: Terminal,
    operationId: any,
  ): Promise<BCCashdropResponseInterface<unknown>> {
    await this.sleep(500);
    if (this.FAKE_IMPORT_OPERATION_STATUS === 'ok') {
      return new BCCashdroResponse(true, { code: 1, response: '' }, null);
    } else {
      switch (this.FAKE_IMPORT_OPERATION_WRONG_STATUS) {
        // Incorrect user and/or password
        case 'authentication_error':
          return this.getCashdroAuthenticationExceptionResponse();
          break;
        // Impossible to connect with the terminal
        case '404':
          return this.getCashdroConnectionExceptionResponse();
          break;
        case 'operation_not_found': {
          const responseData = {
            code: -2,
            response: {
              errorMessage: 'Operation not found"',
            },
          };
          return new BCCashdroResponse(
            false,
            responseData,
            this.$errorHelper.cashdroOperationIsNotInExecutionError(),
          );
          break;
        }
        case 'invalid_parameters': {
          const responseData = {
            code: -3,
            response: {
              errorMessage: 'Invalid parameters"',
            },
          };
          return new BCCashdroResponse(
            false,
            responseData,
            this.$errorHelper.cashdroInvalidParametersError(),
          );
          break;
        }
        default:
          return this.getCashdroGenericExceptionResponse();
          break;
      }
    }
  }

  FAKE_CANCEL_OPERATION_STATUS = 'ok';
  // Global errors: '404' | 'authentication_error'
  // Specific erors for getOperationStatus : 'operation_is_not_in_execution' | 'invalid_parameters' | 'cashdro_not_running'
  FAKE_CANCEL_OPERATION_WRONG_STATUS = 'cashdro_not_running';
  async cancelOperation(
    terminal: Terminal,
    operationId: any,
  ): Promise<BCCashdropResponseInterface<unknown>> {
    await this.sleep(500);
    if (this.FAKE_CANCEL_OPERATION_STATUS === 'ok') {
      return new BCCashdroResponse(true, { code: 1, response: '' }, null);
    } else {
      switch (this.FAKE_CANCEL_OPERATION_WRONG_STATUS) {
        // Incorrect user and/or password
        case 'authentication_error':
          return this.getCashdroAuthenticationExceptionResponse();
          break;
        // Impossible to connect with the terminal
        case '404':
          return this.getCashdroConnectionExceptionResponse();
          break;
        case 'operation_is_not_in_execution': {
          const responseData = {
            code: -2,
            response: {
              errorMessage: 'Operation not found"',
            },
          };
          return new BCCashdroResponse(
            false,
            responseData,
            this.$errorHelper.cashdroOperationIsNotInExecutionError(),
          );
          break;
        }
        case 'invalid_parameters': {
          const responseData = {
            code: -99,
            response: {
              errorMessage: 'Invalid parameters"',
            },
          };
          return new BCCashdroResponse(
            false,
            responseData,
            this.$errorHelper.cashdroInvalidParametersError(),
          );
          break;
        }
        case 'cashdro_not_running': {
          const responseData = {
            code: -999,
            response: {
              errorMessage: 'Cashdro service is not running',
            },
          };
          return new BCCashdroResponse(
            false,
            responseData,
            this.$errorHelper.cashdroServiceStoppedError(),
          );
          break;
        }
        default:
          return this.getCashdroGenericExceptionResponse();
          break;
      }
    }
  }

  FAKE_FINALIZE_OPERATION_STATUS = 'ok';
  // Global errors: '404' | 'authentication_error'
  // Specific erors for finalizeOperation : 'operation_is_not_in_execution' | 'invalid_parameters' | 'cashdro_not_running'
  FAKE_FINALIZE_OPERATION_WRONG_STATUS = 'invalid_parameters';
  async finalizeOperation(
    terminal: Terminal,
    operationId: any,
  ): Promise<BCCashdropResponseInterface<unknown>> {
    await this.sleep(500);
    if (this.FAKE_FINALIZE_OPERATION_STATUS === 'ok') {
      return new BCCashdroResponse(true, { code: 1, response: '' }, null);
    } else {
      switch (this.FAKE_FINALIZE_OPERATION_WRONG_STATUS) {
        // Incorrect user and/or password
        case 'authentication_error':
          return this.getCashdroAuthenticationExceptionResponse();
          break;
        // Impossible to connect with the terminal
        case '404':
          return this.getCashdroConnectionExceptionResponse();
          break;
        case 'operation_is_not_in_execution': {
          const responseData = {
            code: -2,
            response: {
              errorMessage: 'Operation not found"',
            },
          };
          return new BCCashdroResponse(
            false,
            responseData,
            this.$errorHelper.cashdroOperationIsNotInExecutionError(),
          );
          break;
        }
        case 'invalid_parameters': {
          const responseData = {
            code: -99,
            response: {
              errorMessage: 'Invalid parameters"',
            },
          };
          return new BCCashdroResponse(
            false,
            responseData,
            this.$errorHelper.cashdroInvalidParametersError(),
          );
          break;
        }
        case 'cashdro_not_running': {
          const responseData = {
            code: -999,
            response: {
              errorMessage: 'Cashdro service is not running',
            },
          };
          return new BCCashdroResponse(
            false,
            responseData,
            this.$errorHelper.cashdroServiceStoppedError(),
          );
          break;
        }
        default:
          return this.getCashdroGenericExceptionResponse();
          break;
      }
    }
  }

  FAKE_EXECUTE_OPERATION_STATUS = 'ok';
  // Global errors: '404' | 'authentication_error'
  // Specific erors for executeOperation : 'operation_does_not_exist' | 'invalid_parameters'
  FAKE_EXECUTE_OPERATION_WRONG_STATUS = 'invalid_parameters';
  async executeOperation(
    terminal: Terminal,
    operationId: any,
  ): Promise<BCCashdropResponseInterface<unknown>> {
    await this.sleep(500);
    if (this.FAKE_EXECUTE_OPERATION_STATUS === 'ok') {
      return new BCCashdroResponse(true, { code: 1, response: { errorMessage: 'none' } }, null);
    } else {
      switch (this.FAKE_EXECUTE_OPERATION_WRONG_STATUS) {
        // Incorrect user and/or password
        case 'authentication_error':
          return this.getCashdroAuthenticationExceptionResponse();
          break;
        // Impossible to connect with the terminal
        case '404':
          return this.getCashdroConnectionExceptionResponse();
          break;
        case 'operation_does_not_exist': {
          const responseData = {
            code: -2,
            response: {
              errorMessage: 'Operation not found"',
            },
          };
          return new BCCashdroResponse(
            false,
            responseData,
            this.$errorHelper.cashdroOperationDoesNotExistException(),
          );
          break;
        }
        case 'invalid_parameters': {
          const responseData = {
            code: -3,
            response: {
              errorMessage: 'Invalid parameters"',
            },
          };
          return new BCCashdroResponse(
            false,
            responseData,
            this.$errorHelper.cashdroInvalidParametersError(),
          );
          break;
        }
        default:
          return this.getCashdroGenericExceptionResponse();
          break;
      }
    }
  }

  FAKE_TERMINAL_STATUS = 'ok'; // change to ko to test FAKE WRONG STATUS terminal errors
  FAKE_TERMINAL_WRONG_STATUS = ''; // Global errors: '404' | 'authentication_error'

  async getTerminalStatus(terminal: Terminal): Promise<BCCashdropResponseInterface<unknown>> {
    await this.sleep(500);
    if (this.FAKE_TERMINAL_STATUS === 'ok') {
      return new BCCashdroResponse(true, { code: 1, response: '' }, null);
    } else {
      switch (this.FAKE_TERMINAL_WRONG_STATUS) {
        // Incorrect user and/or password
        case 'authentication_error':
          return this.getCashdroAuthenticationExceptionResponse();
          break;
        // Impossible to connect with the terminal
        case '404':
          return this.getCashdroConnectionExceptionResponse();
          break;
        default:
          return this.getCashdroGenericExceptionResponse();
          break;
      }
    }
  }

  /* Use cross training article 15€ */
  FAKE_OPERATION_STATUS = 'ok';
  // Global errors: '404' | 'authentication_error'
  // Specific erors for getOperationStatus : 'operation_with_errors' | 'operation_with_amount_change_not_available' | operation_does_not_exist
  FAKE_OPERATION_WRONG_STATUS = 'operation_with_amount_change_not_available';
  FAKE_OPERATION_STATE = 'F'; // can be I = the operation does not exist , Q => the operation is queued,  E => the operation is running , F => Finished.
  FAKE_OPERATION_TOTAL = '100'; // Amount of the operation
  FAKE_OPERATION_TOTAL_IN = '200'; // Total amount inserted in CashDro.
  FAKE_OPERATION_TOTAL_OUT = '0'; // Total amount returned by CashDro
  FAKE_OPERATION_WITH_ERROR = 'false'; // . Indicates if CashDro is operative or error status (for example, jammed note,..).
  FAKE_OPERATION_AMOUNT_CHANGE_NOT_AVAILABLE = '100';
  FAKE_OPERATION_FINAL_STATUS = 2; // "2" ->  Finalized | "4" -> Cancelled

  FAKE_OPERATION_WITH_MESSAGES = [
    'Unit rejected because of lack of change.',
    'Unit not recyclable.',
    'Unit not accepted temporarily.',
    'Unit not accepted.',
    'Unit not recognized.',
    'Recycler is full.',
    'Full escrow.',
    'Full escrow and recycler.',
    'Non recyclable or full recycler.',
  ];

  async getOperationStatus(
    terminal: Terminal,
    operationId: number,
  ): Promise<BCCashdropResponseInterface<unknown>> {
    await this.sleep(500);
    if (this.FAKE_OPERATION_STATUS === 'ok') {
      const responseData: BCCashdroOperationsStatusResponse = {
        code: 1,
        operation: {
          operationId: operationId,
          state: this.FAKE_OPERATION_STATE,
          total: parseInt(this.FAKE_OPERATION_TOTAL),
          totalin: parseInt(this.FAKE_OPERATION_TOTAL_IN),
          totalout: parseInt(this.FAKE_OPERATION_TOTAL_OUT),
          amountchangenotavailable: parseInt(this.FAKE_OPERATION_AMOUNT_CHANGE_NOT_AVAILABLE),
          withError: false,
          messages: [],
          payInProgress: parseInt('0'),
          payOutProgress: parseInt('0'),
          posUser: 'posUser',
          posId: 'invoiceId',
          finalStatus: this.FAKE_OPERATION_FINAL_STATUS,
        },
      };

      return new BCCashdroResponse(true, responseData, null);
    } else {
      switch (this.FAKE_OPERATION_WRONG_STATUS) {
        // Incorrect user and/or password
        case 'authentication_error':
          return this.getCashdroAuthenticationExceptionResponse();
          break;
        // Impossible to connect with the terminal
        case '404':
          return this.getCashdroConnectionExceptionResponse();
          break;
        case 'operation_with_errors': {
          const responseData: BCCashdroOperationsStatusResponse = {
            code: 1,
            operation: {
              operationId: operationId,
              state: this.FAKE_OPERATION_STATUS,
              total: parseInt(this.FAKE_OPERATION_TOTAL),
              totalin: parseInt(this.FAKE_OPERATION_TOTAL_IN),
              totalout: parseInt(this.FAKE_OPERATION_TOTAL_OUT),
              amountchangenotavailable: 0,
              withError: this.FAKE_OPERATION_WITH_ERROR === 'false' ? false : true,
              messages: this.FAKE_OPERATION_WITH_MESSAGES,
              payInProgress: 0,
              payOutProgress: 0,
            },
          };
          return new BCCashdroResponse(
            false,
            responseData,
            this.$errorHelper.cashdroOperationWithError(),
          );
          break;
        }
        case 'operation_with_amount_change_not_available': {
          const responseData: BCCashdroOperationsStatusResponse = {
            code: 1,
            operation: {
              operationId: operationId,
              state: this.FAKE_OPERATION_STATUS,
              total: parseInt(this.FAKE_OPERATION_TOTAL),
              totalin: parseInt(this.FAKE_OPERATION_TOTAL_IN),
              totalout: parseInt(this.FAKE_OPERATION_TOTAL_OUT),
              amountchangenotavailable: parseInt(this.FAKE_OPERATION_AMOUNT_CHANGE_NOT_AVAILABLE),
              withError: this.FAKE_OPERATION_WITH_ERROR === 'false' ? false : true,
              messages: this.FAKE_OPERATION_WITH_MESSAGES,
              payInProgress: 0,
              payOutProgress: 0,
            },
          };
          return new BCCashdroResponse(
            false,
            responseData,
            this.$errorHelper.cashdroOperationWithAmountChangeNotAvailableError(),
          );
          break;
        }
        case 'operation_does_not_exist': {
          const responseData: BCCashdroOperationsStatusResponse = {
            code: 1,
            operation: {
              operationId: operationId,
              state: 'I',
              total: parseInt(this.FAKE_OPERATION_TOTAL),
              totalin: parseInt(this.FAKE_OPERATION_TOTAL_IN),
              totalout: parseInt(this.FAKE_OPERATION_TOTAL_OUT),
              amountchangenotavailable: null,
              withError: this.FAKE_OPERATION_WITH_ERROR === 'false' ? false : true,
              messages: this.FAKE_OPERATION_WITH_MESSAGES,
              payInProgress: 0,
              payOutProgress: 0,
            },
          };
          return new BCCashdroResponse(
            false,
            responseData,
            this.$errorHelper.cashdroOperationDoesNotExistException(),
          );
          break;
        }
        default:
          return this.getCashdroGenericExceptionResponse();
          break;
      }
    }
  }

  FAKE_EXECUTING_TERMINAL_OPERATION_STATUS = 'ok';
  // Global errors: '404' | 'authentication_error'
  FAKE_EXECUTING_TERMINAL_OPERATION_WRONG_STATUS = 'operation_in_executon';
  // Specific erors for getTerminalAvailability : 'operation_in_executon'

  async getExecutingTerminalOperations(
    terminal: Terminal,
  ): Promise<BCCashdropResponseInterface<unknown>> {
    await this.sleep(400);
    if (this.FAKE_EXECUTING_TERMINAL_OPERATION_STATUS === 'ok') {
      const responseData: BCCashdroExecutingOperationsResponse = {
        code: 1,
        operationId: 'fake_operation_id',
        type: '4',
      };

      return new BCCashdroResponse(true, { code: 1, response: '' }, null);
    } else {
      switch (this.FAKE_EXECUTING_TERMINAL_OPERATION_WRONG_STATUS) {
        // Incorrect user and/or password
        case 'authentication_error':
          return this.getCashdroAuthenticationExceptionResponse();
          break;
        // Impossible to connect with the terminal
        case '404':
          return this.getCashdroConnectionExceptionResponse();
          break;
        case 'operation_in_executon': {
          const responseData: BCCashdroExecutingOperationsResponse = {
            code: 1,
            operationId: 'fake_operation_id',
            type: '4',
          };
          /* NOTE: we return an error response because for our system have operation in execution is a bad response */
          return new BCCashdroResponse(
            false,
            responseData,
            this.$errorHelper.cashdroOperationInExecutionError(),
          );
          break;
        }
        default:
          return this.getCashdroGenericExceptionResponse();
          break;
      }
    }
  }

  FAKE_START_OPERATION_STATUS = 'ok';
  // Global errors: '404' | 'authentication_error'
  FAKE_START_OPERATION_WRONG_STATUS = 'operation_in_executon';
  /*
   * Specific erors for startOperation : 'operation_in_executon' | 'wrong_amount' | 'user_doesnt_have_permissions' | 'cant_start_operation' | 'system_busy'
   *  | 'invalid_parameters' | 'operation_does_not_exist'
   */

  async startOperation(
    terminal: Terminal,
    amount: number,
    posId: number,
    contactId: number,
  ): Promise<BCCashdropResponseInterface<unknown>> {
    await this.sleep(2000);
    console.log(this.FAKE_START_OPERATION_STATUS);
    if (this.FAKE_START_OPERATION_STATUS === 'ok') {
      console.log('ok');
      const responseData: CashdroResponse<CashdroStartOperationResponse> = {
        code: 1,
        response: {
          errorMessage: 'none',
          operation: {
            operationId: Math.random(),
          },
        },
      };
      return new BCCashdroResponse(true, responseData, null);
    } else {
      console.log('ko !!' + this.FAKE_START_OPERATION_WRONG_STATUS);
      switch (this.FAKE_START_OPERATION_WRONG_STATUS) {
        // Incorrect user and/or password
        case 'authentication_error':
          return this.getCashdroAuthenticationExceptionResponse();
          break;
        // Impossible to connect with the terminal
        case '404':
          return this.getCashdroConnectionExceptionResponse();
          break;
        case 'operation_in_executon': {
          const responseData: CashdroResponse<CashdroStartOperationResponse> = {
            code: -2,
            response: {
              errorMessage: 'Operation not queued',
            },
          };
          return new BCCashdroResponse(
            false,
            responseData,
            this.$errorHelper.cashdroBusyWithOtherOperationError(),
          );
          break;
        }
        case 'wrong_amount': {
          const responseData: CashdroResponse<CashdroStartOperationResponse> = {
            code: -3,
            response: {
              errorMessage: 'Wrong amount"',
            },
          };
          return new BCCashdroResponse(
            false,
            responseData,
            this.$errorHelper.cashdroIncorrectAmountError(),
          );
          break;
        }
        case 'user_doesnt_have_permissions': {
          const responseData: CashdroResponse<CashdroStartOperationResponse> = {
            code: -4,
            response: {
              errorMessage: 'User does not have',
            },
          };
          return new BCCashdroResponse(
            false,
            responseData,
            this.$errorHelper.cashdroUserDoesNotHavePermissionError(),
          );
          break;
        }
        case 'invalid_parameters': {
          const responseData: CashdroResponse<CashdroStartOperationResponse> = {
            code: -99,
            response: {
              errorMessage: 'Invalid Parameters',
            },
          };
          return new BCCashdroResponse(
            false,
            responseData,
            this.$errorHelper.cashdroInvalidParametersError(),
          );
          break;
        }
        case 'system_busy': {
          const responseData: CashdroResponse<CashdroStartOperationResponse> = {
            code: -1900,
            response: {
              errorMessage: 'System busy',
            },
          };
          return new BCCashdroResponse(
            false,
            responseData,
            this.$errorHelper.cashdroSystemBusyError(),
          );
          break;
        }
        case 'cant_start_operation': {
          const responseData: CashdroResponse<CashdroStartOperationResponse> = {
            code: -998,
            response: {
              errorMessage: "Can't start operation.Check system status on Diagnosis screen",
            },
          };
          return new BCCashdroResponse(
            false,
            responseData,
            this.$errorHelper.cashdroCanNotStartOperationError(),
          );
          break;
        }
        case 'operation_does_not_exist': {
          const responseData: CashdroResponse<CashdroStartOperationResponse> = {
            code: -999,
            response: {
              errorMessage: 'Cashdro service is not runningn',
            },
          };
          return new BCCashdroResponse(
            false,
            responseData,
            this.$errorHelper.cashdroServiceStoppedError(),
          );
          break;
        }
        default:
          return this.getCashdroGenericExceptionResponse();
          break;
      }
    }
  }

  getBasePath(terminal: Terminal, type: string): string {
    const ip = terminal.ip;
    // webservice or html
    const route = type === 'api' ? this.API_ENDPOINT : this.WEB_ENDPOINT;
    const basePath = 'https//' + ip + '/' + route + '/' + 'index.php';
    return basePath;
  }

  getTerminalStatusPath(terminal: Terminal): string {
    const username = terminal.username;
    const password = terminal.password;
    const basePath = this.getBasePath(terminal, 'api');
    const operation = 'doTest';
    const operationQueryParam = 'operation=' + operation;
    const usernameQueryParam = 'name=' + username;
    const passwordQueryParam = 'password=' + password;
    const endpoint =
      basePath + '?' + operationQueryParam + '&' + usernameQueryParam + '&' + passwordQueryParam;
    return endpoint;
  }

  getOperationStatusPath(terminal: Terminal, operationId: number): string {
    const username = terminal.username;
    const password = terminal.password;
    const basePath = this.getBasePath(terminal, 'api');
    const operation = '=askOperationV2';
    const operationQueryParam = 'operation=' + operation;
    const operationIdQueryParam = 'operationId=' + operationId;
    const usernameQueryParam = 'name=' + username;
    const passwordQueryParam = 'password=' + password;
    const endpoint =
      basePath +
      '?' +
      operationQueryParam +
      '&' +
      operationIdQueryParam +
      '&' +
      usernameQueryParam +
      '&' +
      passwordQueryParam;
    return endpoint;
  }

  getExecutingTerminalOperationsPath(terminal: Terminal): string {
    const username = terminal.username;
    const password = terminal.password;
    const basePath = this.getBasePath(terminal, 'api');
    const operation = 'askOperationExecuting';
    const operationQueryParam = 'operation=' + operation;
    const usernameQueryParam = 'name=' + username;
    const passwordQueryParam = 'password=' + password;
    const endpoint =
      basePath + '?' + operationQueryParam + '&' + usernameQueryParam + '&' + passwordQueryParam;
    return endpoint;
  }

  startOperationPath(terminal: Terminal, amount: number, posId: number, contactId: number): string {
    const username = terminal.username;
    const password = terminal.password;
    const basePath = this.getBasePath(terminal, 'api');
    const operation = 'startOperation';
    const operationQueryParam = 'operation=' + operation;
    const usernameQueryParam = 'name=' + username;
    const passwordQueryParam = 'password=' + password;
    const typeQueryParam = 'type=4';
    const posIdQueryParam = 'posid=' + posId;
    const posUserQueryParam = 'posuser=' + contactId;
    const amountQueryParam = 'parameters={"amount":"' + amount + '"}';
    const endpoint =
      basePath +
      '?' +
      operationQueryParam +
      '&' +
      usernameQueryParam +
      '&' +
      passwordQueryParam +
      '&' +
      typeQueryParam +
      '&' +
      posIdQueryParam +
      '&' +
      posUserQueryParam +
      '&' +
      amountQueryParam;
    return endpoint;
  }

  executeOperationPath(terminal: Terminal, operationId: number): string {
    const username = terminal.username;
    const password = terminal.password;
    const basePath = this.getBasePath(terminal, 'api');
    const operation = '=acknowledgeOperationId';
    const operationQueryParam = 'operation=' + operation;
    const operationIdQueryParam = 'operationId=' + operationId;
    const usernameQueryParam = 'name=' + username;
    const passwordQueryParam = 'password=' + password;
    const endpoint =
      basePath +
      '?' +
      operationQueryParam +
      '&' +
      operationIdQueryParam +
      '&' +
      usernameQueryParam +
      '&' +
      passwordQueryParam;
    return endpoint;
  }

  getCancelOperationPath(terminal: Terminal, operationId): string {
    const username = terminal.username;
    const password = terminal.password;
    const basePath = this.getBasePath(terminal, 'api');
    const operation = '=finishOperation';
    const operationQueryParam = 'operation=' + operation;
    const typeQueryParam = 'type=2';
    const operationIdQueryParam = 'operationId=' + operationId;
    const usernameQueryParam = 'name=' + username;
    const passwordQueryParam = 'password=' + password;
    const endpoint =
      basePath +
      '?' +
      operationQueryParam +
      '&' +
      operationIdQueryParam +
      '&' +
      usernameQueryParam +
      '&' +
      passwordQueryParam +
      '&' +
      typeQueryParam;
    return endpoint;
  }

  getFinalizeOperationPath(terminal: Terminal, operationId): string {
    const username = terminal.username;
    const password = terminal.password;
    const basePath = this.getBasePath(terminal, 'api');
    const operation = '=finishOperation';
    const operationQueryParam = 'operation=' + operation;
    const typeQueryParam = 'type=1';
    const operationIdQueryParam = 'operationId=' + operationId;
    const usernameQueryParam = 'name=' + username;
    const passwordQueryParam = 'password=' + password;
    const endpoint =
      basePath +
      '?' +
      operationQueryParam +
      '&' +
      operationIdQueryParam +
      '&' +
      usernameQueryParam +
      '&' +
      passwordQueryParam +
      '&' +
      typeQueryParam;
    return endpoint;
  }

  importOperationPath(terminal: Terminal, operationId: any): string {
    const username = terminal.username;
    const password = terminal.password;
    const basePath = this.getBasePath(terminal, 'api');
    const operation = '=setOperationImported';
    const operationQueryParam = 'operation=' + operation;
    const operationIdQueryParam = 'operationId=' + operationId;
    const usernameQueryParam = 'name=' + username;
    const passwordQueryParam = 'password=' + password;
    const endpoint =
      basePath +
      '?' +
      operationQueryParam +
      '&' +
      operationIdQueryParam +
      '&' +
      usernameQueryParam +
      '&' +
      passwordQueryParam;
    return endpoint;
  }

  getTerminalUnitsAlertsPath(terminal: Terminal): string {
    const username = terminal.username;
    const password = terminal.password;
    const basePath = this.getBasePath(terminal, 'api');
    const operation = 'getAlerts';
    const operationQueryParam = 'operation=' + operation;
    const usernameQueryParam = 'name=' + username;
    const passwordQueryParam = 'password=' + password;
    const endpoint =
      basePath + '?' + operationQueryParam + '&' + usernameQueryParam + '&' + passwordQueryParam;
    return endpoint;
  }

  getTerminalLevelsPath(terminal: Terminal): string {
    const username = terminal.username;
    const password = terminal.password;
    const basePath = this.getBasePath(terminal, 'api');
    const operation = 'getPiecesCurrency';
    const operationQueryParam = 'operation=' + operation;
    const currencyId = 'EUR';
    const currencyIdQueryParam = 'currencyId=' + currencyId;
    const levels = '1';
    const levelsQueryParam = 'currencyId=' + levels;
    const usernameQueryParam = 'name=' + username;
    const passwordQueryParam = 'password=' + password;
    const endpoint =
      basePath +
      '?' +
      operationQueryParam +
      '&' +
      currencyIdQueryParam +
      '&' +
      levelsQueryParam +
      '&' +
      usernameQueryParam +
      '&' +
      passwordQueryParam;
    return endpoint;
  }

  // Helpers
  getCashdroAuthenticationExceptionResponse(): BCCashdropResponseInterface<unknown> {
    return new BCCashdroResponse(
      false,
      { code: -1, response: { errorMessage: 'Authentication Failed' } },
      this.$errorHelper.cashdroAuthenticationError(),
    );
  }
  getCashdroConnectionExceptionResponse(): BCCashdropResponseInterface<unknown> {
    return new BCCashdroResponse(false, {}, this.$errorHelper.cashdroConnectionError());
  }

  getCashdroGenericExceptionResponse(): BCCashdropResponseInterface<unknown> {
    return new BCCashdroResponse(false, {}, this.$errorHelper.genericError());
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
